export default __webpack_public_path__ + "static/media/img-line-start-ev-1.ed5c0774.svg";